import React from 'react';
import { Image, Text, View, Page, Document, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

interface Data{
    date:string,
    companyName:string,
    sector:string,
    strength:string,
    about:string,
    transaction:number,
    target:number,
    stoploss:number,
    valuation:string,
    technical:string,
    news:string
}

interface ProductNoteProps{
    tradeReason:any
}

const ProductNote:React.FC<ProductNoteProps> = ({tradeReason}:any) => {    
    const reciept_data:Data = {
        date:        tradeReason["dt_date"] ? moment((tradeReason["dt_date"]?.toString().split('T')[0])).format("DD MMM YYYY") : '',
        companyName: tradeReason["s_name_of_company"] || '',
        sector:      tradeReason["s_sector"] || '',
        strength:    tradeReason["strength"] || '',
        about:       tradeReason["s_about_company"] || '',
        transaction: Number(tradeReason["n_reco_price"]) || 0,
        target:      Number(tradeReason["n_target"]) || 0,
        stoploss:    Number(tradeReason["n_stoploss"]) || 0,
        valuation:   tradeReason["s_valuation"] ||'',
        technical:   tradeReason["s_technical"] ||'',
        news:        tradeReason["s_news"] ||''
    };


    const styles:any = StyleSheet.create({
        page: {fontSize: 11, paddingTop: 30, paddingLeft: 40, paddingRight: 40, paddingBottom:23, lineHeight: 1.5, flexDirection: 'column'},
        titleContainer: {flexDirection: 'column',alignItems: 'flex-start',textAlign: 'center',justifyContent:'center', marginBottom: 10 },
        logoContainer: {width: '100%', marginBottom: 10, backgroundColor: '#e0e8f9', borderRadius: 6,textAlign: 'center',alignItems: 'center' },
        logo: {width: '60%', height: 'auto' },
        titleStock:{width:'40%',height:'3rem',backgroundColor: '#fab272',borderTopRightRadius: 8,borderBottomRightRadius: 8, alignItems: 'flex-start',justifyContent:'flex-start'},
        reportTitle:{fontSize: 18, fontWeight: 'bold', color: '#333', textAlign: 'center',marginTop:5, marginLeft:8 },
        justifyContentStyle:{textAlign: "justify"},

        detailsContainer:{flexDirection: 'column', alignItems: 'flex-start' },
        text: { color: '#6f6969',fontSize: 10, fontWeight: 700 },
        textstyle: { fontSize: 12, fontWeight: 900, color: 'black' },
        bold: { fontSize: 14, fontWeight: 700 },
        spaces: { marginTop: 10 },
        directionColumn: { width: '100%', padding: 5 },
        disclaimerText: { color: '#6f6969', fontSize: 10, lineHeight: 1.4,marginBottom:3},
        disclaimerTitle: { fontSize: 12, fontWeight: 'bold', marginBottom: 8, textDecoration: 'underline' },

        tableContainer: {flexDirection: 'column',width: '100%',marginTop: 12,marginBottom:12,borderWidth: 1,borderColor: '#cccccc',borderRadius: 4,},
        tableRow: {flexDirection: 'row',textAlign: 'center',},
        tableHeaderRow: {backgroundColor: '#fab272'},
        tableHeader: {paddingVertical: 4,width: '33.33%',fontSize: 13,fontWeight: 'bold',color: 'white',textAlign: 'center',},
        tableData: {width: '33.33%',fontSize: 13,color: '#333',textAlign: 'center',backgroundColor: '#f9f9f9', borderTopWidth: 1,borderColor: '#e0e0e0'},

        footerContainer: {marginTop: 13,paddingTop: 7,borderTop: '1 solid #cccccc',},
        footerTitle: {fontSize: 12,fontWeight: 'bold',marginBottom: 3,},
        footerText: {fontSize: 10,color: '#6f6969',lineHeight: 1.4,},
    });


    return (<>
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.titleContainer}>
                    <View style={styles.logoContainer}>
                        <Image style={styles.logo} src="/images/feedsense_ai_logo1.png"/>
                    </View>
                    <View style={styles.titleStock}>
                        <Text style={styles.reportTitle}>Stock Recommendation</Text>
                    </View>
                </View>

                <View style={[styles.directionColumn, { marginBottom: 5, marginTop: 8 }]}>
                    <View style={styles.detailsContainer}>
                        <Text style={styles.text}>
                            <Text style={styles.textstyle}>Date: </Text> {reciept_data.date}
                        </Text>
                        <Text style={styles.text}>
                            <Text style={styles.textstyle}>Company Name: </Text> {reciept_data.companyName}
                        </Text>
                        <Text style={styles.text}>
                            <Text style={styles.textstyle}>Sector: </Text> {reciept_data.sector}
                        </Text>
                        <Text style={styles.text}>
                            <Text style={styles.textstyle}>Strength: </Text> {reciept_data.strength}
                        </Text>
                    </View>
                    <View style={styles.tableContainer}>
                        <View style={[styles.tableRow, styles.tableHeaderRow]}>
                            <Text style={styles.tableHeader}>Current Price (Rs)</Text>
                            <Text style={styles.tableHeader}>Target (Rs)</Text>
                            <Text style={styles.tableHeader}>Stoploss (Rs)</Text>
                        </View>
                        <View style={styles.tableRow}>
                            <Text style={styles.tableData}>{reciept_data.transaction}</Text>
                            <Text style={styles.tableData}>{reciept_data.target}</Text>
                            <Text style={styles.tableData}>{reciept_data.stoploss}</Text>
                        </View>
                    </View>
                    <Text style={[styles.bold, styles.spaces]}>About company</Text>
                    <Text style={[styles.text, styles.spaces, styles.justifyContentStyle]}>{reciept_data.about}</Text>
                </View>

                <View style={[styles.directionColumn, { marginBottom: 5}]}>
                    {reciept_data.valuation.length > 0 && (
                        <View>
                            <Text style={styles.bold}>Valuation</Text>
                            <Text style={[styles.text,styles.spaces,styles.justifyContentStyle]}>{reciept_data.valuation}</Text>
                        </View>
                    )}
                    {reciept_data.technical.length > 0 && (
                        <View>
                            <Text style={[styles.bold, styles.spaces]}>Technical Indicators</Text>
                            <Text style={[styles.text,styles.spaces,styles.justifyContentStyle]}>{reciept_data.technical}</Text>
                        </View>
                    )}
                    {reciept_data.news.length > 0 && (
                        <View>
                            <Text style={[styles.bold, styles.spaces]}>News</Text>
                            <Text style={[styles.text,styles.spaces,styles.justifyContentStyle]}>{reciept_data.news}</Text>
                        </View>
                    )}
                </View>

                <View style={styles.directionColumn}>
                    <Text style={styles.disclaimerTitle}>RESEARCH ANALYST’S DISCLOSURE AND DISCLAIMER</Text>
                    <Text style={[styles.disclaimerText, styles.justifyContentStyle]}>
                        Feedsense AI Private Limited is registered with Securities and Exchange Board of
                        India (SEBI) as Research Analyst. We are an independent Research Analyst with no
                        parent company affiliations. This document is intended for information purposes only
                        and should not be distributed or reproduced without the permission of Feedsense AI.
                        Past performance is not indicative of future results. Investments in securities involve
                        risk, and investors should consider all related factors, including their financial
                        situation and suitability to risk-return profiles, before making any investment.
                        This material is directed solely to the authorized recipient for informational purposes
                        and is not intended as a solicitation to buy or sell any securities. It does not consider
                        the specific objectives, financial situation, or needs of any individual investor.
                        Recipients should rely on their own investigations and consult their financial advisors
                        before acting on any information provided herein.
                    </Text>
                    <Text style={[styles.disclaimerText, styles.justifyContentStyle]}>
                        The information provided in the Report is from publicly available data, which we
                        believe, are reliable. While reasonable efforts have been made to present reliable
                        data in the Report so far as it relates to current and historical information, but
                        Feedsense AI does not guarantee the accuracy or completeness of the data in the
                        Report. Accordingly, Feedsense AI or any of its connected persons including its
                        directors or subsidiaries or associates or employees shall not be in any way
                        responsible for any loss or damage that may arise to any person from any
                        inadvertent error in the information contained, views and opinions expressed in this
                        publication.
                    </Text>
                    
                    <Text style={[styles.disclaimerText, styles.justifyContentStyle]}>
                        The Report also includes analysis and views of our research team.This report may
                        include forward-looking statements, which are subject to change without notice and
                        should not be taken as predictions. Feedsense AI does not guarantee the
                        completeness or accuracy of the information contained in this report and assumes no
                        liability for any direct or indirect loss arising from its use. Price and value of securities
                        can fluctuate, and there is no assurance that any projected returns will be achieved.
                        This document is solely for the information of clients of Feedsense AI and may not be
                        used or relied upon by anyone else. Certain transactions, such as those involving
                        futures, options, and other derivatives, involve substantial risk and may not be
                        suitable for all investors. Opinions expressed reflect our views as of the date of
                        publication only and may be subject to regulatory, compliance, or other changes.
                        Feedsense AI and its associates collectively do not own (in their proprietary position)
                        1% or more of the equity securities of the subject company/ies mentioned in the
                        report as of the last day of the month preceding the publication of the research
                        report.
                    </Text>
                    <Text style={[styles.disclaimerText, styles.justifyContentStyle]}>
                        The Research Analyst/s engaged in preparation of this Report or his/her relative (a)
                        does not have any financial interests in the subject company/ies mentioned in this
                        report; (b) does not own 1% or more of the equity securities of the subject company
                        mentioned in the report as of the last day of the month preceding the publication of
                        the research report; (c) does not have any other material conflict of interest at the
                        time of publication of the research report.
                        Feedsense AI disclaims liability for any interruptions, delays, or errors in presenting
                        data due to technical issues, internet connectivity, or other system failures. In no
                        event shall Feedsense AI be liable for any damages, including direct, indirect, or
                        consequential damages, arising from the use of this report.
                        The Research Analyst/s engaged in preparation of this Report:- 
                            (a) has not receivedany compensation from the subject company in the past twelve months.
                            (b) has notmanaged or co-managed public offering of securities for the subject company in the past twelve months. 
                            (c) has not received any compensation for investment banking or merchant banking or brokerage services from the subject company in the past twelve months
                            (d) has not received any compensation for products or services other than investment banking or merchant banking or brokerage services from the subject company in the past twelve months.
                            (e) has not received any compensation or other benefits from the subject company or third party in connection with the research report.
                            (f) has not served as an officer, director or employee of the subject company.
                            (g) is not engaged in market making activity for the subject company.
                        We submit that no material disciplinary action has been taken on Feedsense AI by
                        any regulatory authority impacting Equity Research Analysis.
                    </Text>
                    <Text style={[styles.disclaimerText,styles.justifyContentStyle,{fontWeight: 700, color:'black'}]}>
                        Registration granted by SEBI, and certification from NISM in no way guarantee
                        performance of the intermediary or provide any assurance of returns to
                        investors.
                    </Text>
                    <View style={styles.footerContainer}>
                        <Text style={styles.footerTitle}>FEEDSENSE AI PRIVATE LIMITED</Text>
                        <Text style={styles.footerText}>• Registered Office: 44, Park Street, “Saket Building”, 4th Floor, Kolkata-700016, West Bengal.</Text>
                        <Text style={styles.footerText}>• CIN: U73200WB2024PTC268639</Text>
                        <Text style={styles.footerText}>• E-mail: info@feedsense.ai</Text>
                        <Text style={styles.footerText}>• Website: www.Feedsense.ai</Text>
                        <Text style={styles.footerText}>• SEBI RA Regn. Number: INH000018382</Text>
                    </View>
                </View>
            </Page>
        </Document>
        </>
    );
};

export default ProductNote;
